import { message } from "antd";
import { Dispatch, SetStateAction } from "react";
import { useSelectOptions } from "../../../../../hooks/search";
import { SelectOption } from "../../../../../types/select";

type BuildParamsOptions = {
  technicianId?: string;
  timeRange?: { key: string; startDate: string; endDate: string };
  selectedSearchBy?: string;
  searchValue?: string;
  propertyId?: string;
  unitId?: string;
  categoryKey?: string;
};

type UseTicketsSearchOptions = {
  selectedSearchBy: string;
  setSelectedSearchBy: Dispatch<SetStateAction<string>>;
  setSearchValue: Dispatch<SetStateAction<string>>;
};

export const useTicketsSearch = (options: UseTicketsSearchOptions) => {
  const { selectedSearchBy, setSelectedSearchBy, setSearchValue } = options;

  const { selectOptions } = useSelectOptions({ selectedSearchBy });

  function handleSearch(value: string) {
    const length = value?.length ?? 0;

    if (length === 0) {
      setSearchValue("");
      return;
    }

    if (length < 2) {
      message.error("Please enter at least two characters");
      return;
    }

    setSearchValue(value);
  }

  function handleChangeSearchBy(option: SelectOption) {
    setSelectedSearchBy(String(option?.value));
    setSearchValue("");
  }

  function buildParams(options: BuildParamsOptions) {
    const { technicianId, timeRange, selectedSearchBy, searchValue, propertyId, unitId, categoryKey } = options;

    const param: Record<string, any> = {};

    const effectiveCategoryKey = categoryKey ?? "categoryId";

    if (technicianId && technicianId !== "All") param.technicianId = technicianId;

    if (timeRange && timeRange.key !== "all") {
      param.startDate = timeRange.startDate;
      param.endDate = timeRange.endDate;
    }

    if (searchValue) {
      const specialKeys = ["businessUnitId", "ownerName"];

      if (selectedSearchBy && specialKeys.includes(selectedSearchBy)) {
        param[selectedSearchBy] = searchValue;
      } else if (selectedSearchBy && selectedSearchBy !== "All") {
        param[effectiveCategoryKey] = selectedSearchBy;
        param.search = searchValue;
      } else {
        param.search = searchValue;
      }
    }

    if (propertyId) param.propertyId = propertyId;
    if (unitId) param.unitId = unitId;

    return param;
  }

  return { selectOptions, handleSearch, handleChangeSearchBy, buildParams };
};
